import { AnnotationImageDto } from "./annotation-image";
import { AnnotationPhrase, AnnotationPhraseDto } from "./annotation-phrase";
import { AnnotationElement } from "./common";

export class EmbeddedObjectAnnotationDto {

    boundingBox: {
        x1: number;
        x2: number;
        y1: number;
        y2: number;

    }
    annotationPhrases: AnnotationPhraseDto[];
    annotationImages: AnnotationImageDto[];
    docName: string;
    pageCnt: number;
    pagesCnt: number;
    versionId: number;
    docS3Key: string;
    docId: number;
    pageNum: number;
    phrase: string;
    catImageS3Key: string;
}

export class EmbeddedObjectAnnotation {
    
    boundingBox: AnnotationElement;
    annotationPhrases: { [key: number]: AnnotationElement[] } = {};
    docName: string;
    startingPhrase?: string;
    anchorPath?: string;
    originalAnchorPath?: string;
    pageCnt: number;
    versionId: number;
    docS3Key: string;
    docId: number;
    pageNum: number;
    phrase: string;
    catImageS3Key: string;
    imgUrl: string;
    hasImage: boolean = false

    copy(embeddedObjectAnnotation: EmbeddedObjectAnnotation) {
        
        this.docName = embeddedObjectAnnotation.docName;
        this.startingPhrase = embeddedObjectAnnotation.startingPhrase;
        this.anchorPath = embeddedObjectAnnotation.anchorPath;
        this.originalAnchorPath = embeddedObjectAnnotation.originalAnchorPath;
        this.pageCnt = embeddedObjectAnnotation.pageCnt;
        this.versionId = embeddedObjectAnnotation.versionId;
        this.docS3Key = embeddedObjectAnnotation.docS3Key;
        this.docId = embeddedObjectAnnotation.docId;
        this.pageNum = embeddedObjectAnnotation.pageNum;
        this.phrase = embeddedObjectAnnotation.phrase;
        this.catImageS3Key = embeddedObjectAnnotation.catImageS3Key;
        this.imgUrl = embeddedObjectAnnotation.imgUrl;

        // can make shallow copy because we dont change this after initialization
        this.boundingBox = embeddedObjectAnnotation.boundingBox;
        this.annotationPhrases = embeddedObjectAnnotation.annotationPhrases;
    }
}